import type { Component } from '@which/glide-ts-types'
import { InPageAnchorLink, Typography } from '@which/seatbelt'

import * as articlePageComponents from '../../pages/article/components'
import { FreeArticleSignup } from '../../pages/article/components/FreeArticleSignup/FreeArticleSignup'
import * as localComponent from '../components'
import { Link } from '../components/Link'

type AllowedKeys = Component | keyof typeof localComponent | 'FreeArticleSignup'

export const componentMap = {
  ...localComponent,
  ...articlePageComponents,
  AcastPodcast: localComponent.IframeEmbed,
  NetworkCoverageMap: localComponent.IframeEmbed,
  StandardLink: Link,
  InPageAnchorLink,
  Typography,
  PICategoriesSection: localComponent.PICategories,
  PITopicsSection: localComponent.PITrendingTopicsSection,
  PILatestReleasesSection: undefined,
  PIHeader: localComponent.PIHeader,
  PISearchContent: localComponent.PISearchContent,
  FreeArticleSignup,
} satisfies Partial<Record<AllowedKeys, unknown>>

export type ComponentMap = typeof componentMap
